import { ContentPreview } from '@app/store/shared';
import { ModuleDto, LessonPreviewDto, DurationDto, DurationItemDto } from './module.dto';

export class Module {
    id: string;
    name: string;
    lessonNext: LessonPreview;
    items: ContentPreview[];
    description: string;
    duration: Duration;

    constructor(data: ModuleDto) {
        this.id = data.id;
        this.name = data.name;
        this.lessonNext = new LessonPreview(data.lessonNext);
        this.items = data.items.map((item) => new ContentPreview(item));
        this.description = data.description;
        this.duration = new Duration(data.duration);
    }
}

export class Duration {
    video: DurationItem;
    audio: DurationItem;
    document: DurationItem;

    constructor(data: DurationDto) {
        this.video = new DurationItem(data.video);
        this.audio = new DurationItem(data.audio);
        this.document = new DurationItem(data.document);
    }
}

export class DurationItem {
    total: number;
    completed: number;
    remaining: number;

    constructor(data: DurationItemDto) {
        this.total = data.total;
        this.completed = data.completed;
        this.remaining = data.total - data.completed;
    }
}

export class LessonPreview {
    id: string;
    name: string;

    constructor(data: LessonPreviewDto) {
        this.id = data.id;
        this.name = data.name;
    }
}
